import { connect } from 'react-redux'
import { Update } from './Reset'
export { Update }
export default connect(({tokens}) => tokens)(Update)